// ABOUTME: A listing's own words, as the operator wrote them (the editor's HTML or the small markdown), rendered block
// ABOUTME: by block as React text (listingText.ts reads them): headings, lists, paragraphs, http(s) links in a new tab.
import { Fragment } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { Text } from 'components/Text';
import { ListingTextPart, toBlocks } from '../listingText';

/** A block's text, its http(s) links (the only ones listingText keeps) opening in a new tab without the opener. */
const Inline = ({
  text,
  parts
}: {
  text: string;
  parts?: ListingTextPart[];
}) =>
  parts ? (
    <>
      {parts.map((part, index) =>
        part.href ? (
          <Link
            key={index}
            href={part.href}
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
          >
            {part.text}
          </Link>
        ) : (
          <Fragment key={index}>{part.text}</Fragment>
        )
      )}
    </>
  ) : (
    <>{text}</>
  );

export const ListingText = ({
  text,
  testId
}: {
  text: string;
  testId?: string;
}) => (
  <Box data-testid={testId} sx={{ display: 'grid', gap: 1 }}>
    {toBlocks(text).map((block, index) => {
      if (block.kind === 'heading') {
        return (
          <Text
            key={index}
            variant="body2"
            component="h3"
            color="text.primary"
            sx={{ fontWeight: 700, mt: index ? 1 : 0 }}
          >
            <Inline text={block.text} parts={block.parts} />
          </Text>
        );
      }
      if (block.kind === 'bullets') {
        return (
          <Box
            key={index}
            component={block.ordered ? 'ol' : 'ul'}
            sx={{ m: 0, pl: 2.5, display: 'grid', gap: 0.5 }}
          >
            {block.items.map((item, itemIndex) => (
              <Text
                key={itemIndex}
                variant="body2"
                component="li"
                color="text.primary"
              >
                <Inline text={item} parts={block.parts?.[itemIndex]} />
              </Text>
            ))}
          </Box>
        );
      }
      return (
        <Text
          key={index}
          variant="body2"
          component="p"
          color="text.primary"
          sx={{ whiteSpace: 'pre-line' }}
        >
          <Inline text={block.text} parts={block.parts} />
        </Text>
      );
    })}
  </Box>
);
